import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class OngoingDraftService extends Service {
  constructor({httpRepository, cookieRepository}) {
    super()
    this._httpRepository = httpRepository
    this._cookieRepository = cookieRepository
  }

  /**
   * @return {Promise<DraftEntity, Error>} returns the draft entity
   */
  @inlineError
  async execute({categoryId, userEntity}) {
    const getDraft = userEntity ? this._httpRepository.ongoingDraft : this._cookieRepository.getAnonymousDraft
    const [ongoingError, ongoingResponse] = await getDraft({categoryId, userEntity})

    if (ongoingError) {
      return Promise.reject(ongoingError)
    }
    return ongoingResponse
  }
}
